import DxButton from "devextreme-react/button";
import {
	ButtonStyle,
	ButtonType,
	ClickEvent,
} from "devextreme/ui/button_types";
import { useLanguage } from "../../hooks/useLanguage";
import "./ItiButton.scss";

interface ItiButtonProps {
	text?: string;
	hint?: string;
	tabIndex?: number;
	stylingMode?: ButtonStyle;
	className?: string;
	type?: ButtonType;
	disabled?: boolean;
	visible?: boolean;
	icon?: string;
	useSubmitBehavior?: boolean;
	elementAttr?: any;
	width?: number | string;
	onClick?: (e: ClickEvent) => void;
}

export default function ItiButton({
	text,
	hint,
	tabIndex,
	type,
	stylingMode = "outlined",
	className,
	disabled = false,
	visible = true,
	icon,
	useSubmitBehavior,
	elementAttr,
	width,
	onClick,
}: Readonly<ItiButtonProps>) {
	const { t } = useLanguage();
	const completeClassName = `${className} dx-button`;

	return (
		<DxButton
			tabIndex={tabIndex}
			className={completeClassName}
			stylingMode={stylingMode}
			type={type}
			text={text ? t(text) : undefined}
			hint={hint}
			onClick={onClick}
			icon={icon}
			visible={visible}
			disabled={disabled}
			useSubmitBehavior={useSubmitBehavior}
			elementAttr={elementAttr}
			width={width}
		/>
	);
}
